module.exports = __webpack_public_path__ + "img/plan6.a208772d.png";